export default {

    /**
     * Get tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getTriggers: state => (node_id) => {

        // Get list
        let lst = Object.values(state.triggers).filter((ut) => (ut.node_id == node_id));

        // Return tasks list
        return lst
    },

    /**
     * Get trigger by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByID: state => (id) => {
        // Return trigger list
        return state.triggers[id];
    }

}
